import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import Basket from "../../Components/Basket/Basket";
import { fetchRetailers } from "../../Reducers/Login/Actions";
import { deleteBasketItem, sendMail, setSelectedAmount, setSelectedBasketItem, updateBasket } from "../../Reducers/Basket/Actions";
import ProductVariant from "../ProductVariant/ProductVariant";

const BasketContainer = (props) => {
  const dispatch = useDispatch();
  const { isLoggedIn, selectedSkiSchool, retailers } = useSelector(state => state.login);
  const { items, selectedBasketItem, clearData, mailFailed } = useSelector(state => state.basket);
  const { loadIdentifier } = useSelector(state => get(state, "configurator"));

  return (<Basket
            {...props}
            isLoggedIn={isLoggedIn}
            selectedSkiSchool={selectedSkiSchool}
            retailers={retailers}
            fetchRetailers={() => dispatch(fetchRetailers())}
            basketItems={items}
            selectedItem={selectedBasketItem}
            deleteBasketItem={(id) => dispatch(deleteBasketItem(id))}
            selectItem={(item) => dispatch(setSelectedBasketItem(item))}
            handleAmountUpdate={(variant, size, amount) => dispatch(setSelectedAmount(amount, variant.identifier))}
            updateBasket={(item) => dispatch(updateBasket(item))}
            sendMail={async (data) => await dispatch(sendMail(data))}
            loadIdentifier={loadIdentifier}
            clearData={clearData}
            mailFailed={mailFailed}
            ProductVariantComponent={ProductVariant}
        />
      )
  }

export default BasketContainer